import { Fragment } from 'react'
import { NextBtn, PrevBtn } from '../../../../widgets/AppBtn';

const YearlyBudgetListView = ({ onAcaListData, fetchAcademicsListView }) => {
    return (
        <Fragment>
            <div className='bg-white rounded-md p-2 shadow-sm dark:bg-slate800 overflow-y-auto '>
                <div className="relative overflow-x-auto">
                    <table className="text-sm text-left rtl:text-right text-gray-100 whitespace-nowrap scroll-x-auto dark:text-gray-400 rounded w-full">
                        <thead className="text-[13px] text-gray700 bg-slate300 capitalize border-b dark:bg-slate900 dark:text-gray-400 font-public-sans">
                            <tr>
                                <th scope="col" align='center' className="px-2 py-1.5 border border-gray300 dark:border-slate600 w-10">
                                    {"S.N."}
                                </th>
                                <th scope="col" className="px-2 py-1.5 border-gray300 border dark:border-slate600">
                                    {"Fiscal Year"}
                                </th>
                                <th scope="col" className="px-2 py-1.5 border-gray300 border dark:border-slate600">
                                    {"Ledger"}
                                </th>
                                <th scope="col" className="px-2 py-1.5 border-gray300 border dark:border-slate600">
                                    {"Estimated Amount"}
                                </th>
                            </tr>
                        </thead>
                        <tbody className='text-slate-800'>
                            {
                                Array.isArray(onAcaListData?.results) && onAcaListData?.results?.map((fees, index) => (
                                    <tr key={index} className="odd:bg-white text-[12px] text-gray-700 dark:text-gray-400 odd:dark:bg-slate800 even:bg-gray-50 even:dark:bg-slate700 border-b font-public-sans dark:border-gray-700">
                                        <td align='center' className="px-2 border dark:border-slate600 py-1 border-gray300 capitalize">
                                            {index + 1}.
                                        </td>
                                        <td align='left' className="px-2 border font-medium dark:border-slate600 border-gray300 capitalize">
                                            {fees?.fiscal_year_name}
                                        </td>
                                        <td align='left' className="px-2 border dark:border-slate600 border-gray300 capitalize">
                                            {fees?.sub_led_name}
                                        </td>
                                        <td align='left' className="px-2 border dark:border-slate600 border-gray300 capitalize">
                                            {fees?.estimated_amount}
                                        </td>
                                    </tr>
                                ))
                            }
                        </tbody>
                    </table>

                </div>

            </div>
            <div className='flex justify-end gap-4 mt-5'>
                <PrevBtn disabled={onAcaListData?.previous === null ? true : false} onClick={async () => {
                    if (onAcaListData?.previous) {
                        await fetchAcademicsListView(onAcaListData?.previous);
                    }
                }} /> <NextBtn disabled={onAcaListData?.next === null ? true : false} onClick={async () => {
                    if (onAcaListData?.next) {
                        await fetchAcademicsListView(onAcaListData?.next);
                    }
                }} />
            </div>
        </Fragment>
    )
}

export default YearlyBudgetListView